export type ApiErrorKind = 'bad-request' | 'forbidden' | 'not-found' | 'server'

export function getErrorStatus(error: unknown): number | undefined {
  if (typeof error !== 'object' || error === null) return undefined
  const response = (error as { response?: { status?: unknown } }).response
  return typeof response?.status === 'number' ? response.status : undefined
}

/**
 * 403 means "no access" (a missing role or token returns 403, not 401).
 * Anything that is not a recognised client error is treated as a generic,
 * retryable failure.
 */
export function classifyError(error: unknown): ApiErrorKind {
  const status = getErrorStatus(error)
  if (status === 400) return 'bad-request'
  if (status === 401 || status === 403) return 'forbidden'
  if (status === 404) return 'not-found'
  return 'server'
}

/** 4xx responses will not fix themselves, so they are never retried/polled. */
export function isClientError(error: unknown): boolean {
  const status = getErrorStatus(error)
  return status !== undefined && status >= 400 && status < 500
}

/** Retry a failed query once, and only when the failure could be transient. */
export function shouldRetryQuery(failureCount: number, error: unknown) {
  return !isClientError(error) && failureCount < 1
}
